"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utilsJs = require("@agro1desenvolvimento/utils-js");

const localStorage = new _utilsJs.LocalStorage();
var _default = localStorage;
exports.default = _default;